import React from 'react';
import { FontIcon, RaisedButton, FlatButton } from "material-ui";

export default ({
  preconfirmed,
  newUserInfo = {},
  assetOwnerEmail,
  viewAs,
  autoLogin,
  ratesOrRequests,
  scheduleDemo,
}) => {
  return (
    <div style={{ padding: '24px', textAlign: 'center', whiteSpace: 'pre-wrap', display: 'flex', flexDirection: 'column' }}>
      <FontIcon
        className={'tc-icon-paperplane'}
        color={'#27cfc3'}
        style={{ fontSize: '50px', marginBottom: '16px' }}
      />
      {(() => {
        if (preconfirmed) {
          if (newUserInfo.newCompany) {
            return (
              <div data-cy="confirmed-newcompany-success" style={{ width: '85%', margin: 'auto' }}>
                <h3>Thank you for creating a TourConnect account!</h3>
                <div>We've added all of the {ratesOrRequests} sent to {assetOwnerEmail} to your account.</div>
                <div className="flex-tc-sb" style={{ width: '80%', margin: '32px auto 0' }}>
                  <FlatButton
                    label="Schedule A Demo"
                    style={{ border: '1px solid #00bcd4' }}
                    labelStyle={{ textTransform: 'none', color: '#00bcd4' }}
                    onTouchTap={scheduleDemo}
                  />
                  <RaisedButton
                    secondary
                    label="View Contract List"
                    data-cy="goToContractList"
                    labelStyle={{ textTransform: 'none' }}
                    onTouchTap={autoLogin}
                  />
                </div>
              </div>
            )
          }
          return (
            <div data-cy="confirmed-existingcompany-success" style={{ width: '80%', margin: 'auto' }}>
              <h3>Thank you for creating a TourConnect account!</h3>
              <b>We have sent your request to join the {newUserInfo.companyName} account on TourConnect.</b>
              <br/>
              <br/>
              <div>
                For security purposes, the administrator of the {newUserInfo.companyName} account will need to approve you as a user before you can log in. We will notify you once you have been approved.
              </div>
            </div>
          )
        }
        if (newUserInfo.newCompany) {
          return (
            <div data-cy="notconfirmed-newcompany-success" style={{ width: '80%', margin: 'auto' }}>
              <h3>You're almost done. Check your email.</h3>
              <div>
                For security purposes, we need to confirm your email address. Please check your email and click on the link to confirm your account -
                <i>please, remember to check your SPAM and trash folders</i>!
              </div>
            </div>
          )
        }
        return (
          <div data-cy="notconfirmed-existingcompany-success" style={{ width: '80%', margin: 'auto' }}>
            <h3>You're almost done. Check your email.</h3>
            <div>
              For security purposes, we need to confirm your email address. Please check your email and click on the link to confirm your account -
              <i>please, remember to check your SPAM and trash folders</i>!
            </div>
            <br/>
            <div>Once you confirm your email address, the administrator of the {newUserInfo.companyName} account will need to approve you as a user before you can log in.</div>
          </div>
        )
      })()}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/dialog/success.jsx